// extracted by mini-css-extract-plugin
export default {"vehicle-info":"vehicle-info_vehicle-info__EfFc8","row":"vehicle-info_row__P6-eq"};